import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 28,
	viewBox: "0 0 30 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.323 5.79761C15.5438 5.79761 15.7236 5.96551 15.7236 6.17308L15.7236 26.4053C15.7236 26.6115 15.5438 26.7794 15.323 26.7794C15.1021 26.7794 14.9225 26.6115 14.9225 26.4053L14.9225 6.17308C14.9225 5.96551 15.1021 5.79761 15.323 5.79761Z",
			fill: "#272525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.26845 -2.3277e-06L29.3786 -3.27106e-08C29.5995 -1.46798e-08 29.7793 0.167919 29.7793 0.37549L29.7793 13.5503C29.7793 13.7578 29.5995 13.9244 29.3786 13.9244C29.155 13.9244 28.9752 13.7578 28.9752 13.5503L28.9752 0.74964L1.66911 0.749637L1.6691 13.5503C1.6691 13.7578 1.49071 13.9244 1.26845 13.9244C1.0476 13.9244 0.867793 13.7578 0.867793 13.5503L0.867794 0.375487C0.867794 0.167917 1.0476 -2.34574e-06 1.26845 -2.3277e-06Z",
			fill: "#272525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3475 22.7034L12.6745 22.8594L15.3232 26.3299L17.9706 22.8594C18.0995 22.6928 18.3501 22.6531 18.5299 22.7721C18.7111 22.8924 18.7535 23.1278 18.6247 23.2957L15.649 27.1932C15.4989 27.3902 15.1463 27.3902 14.9963 27.1932L12.0219 23.2957C11.8931 23.1278 11.9342 22.8924 12.1154 22.7721L12.3475 22.7034Z",
			fill: "#272525"
		})
	]
});
export { SvgDownload as ReactComponent };
